import { DEPUTY_ENUM, DEPUTY_GROUP } from './deputy';

export const generateDefaultScreenRoute = (screen: number) => {
  switch (screen) {
    case 1:
      return `/group/${DEPUTY_GROUP.MAIN}`;
    case 2:
      return `/${DEPUTY_ENUM.PREVENTION}`;
    case 3:
      return `/${DEPUTY_ENUM.PUBLIC}`;
    case 4:
      return `/${DEPUTY_ENUM.ERADICATION}`;
    case 5:
      return `/${DEPUTY_ENUM.REHAB}`;
    case 6:
      return `/${DEPUTY_ENUM.LEGAL}`;
    case 7:
      return `/group/${DEPUTY_GROUP.RESEARCH}`;
    default:
      return `/group/${DEPUTY_GROUP.MAIN}`;
  }
};
